/**
 * Constantes unificadas para los tipos de supervisión.
 * Usadas en Supervision, Supervised y sus reducers/actions.
 */
export const SUPERVISION_TYPES = {
  SETTLEMENT: "SETTLEMENT",
  MANUAL_NOTE: "MANUAL_NOTE",
};

export const SUPERVISION_TYPE_LABELS = {
  [SUPERVISION_TYPES.SETTLEMENT]: "Liquidación",
  [SUPERVISION_TYPES.MANUAL_NOTE]: "Mayorista",
};
